
import { Link } from "react-router-dom";
import { Mail, Clock } from "lucide-react";

export const HebrewContactInfo = () => {
  return (
    <div className="mt-12 mb-8 p-6 bg-blue-50 rounded-lg">
      <h2 className="text-xl font-semibold mb-4 text-blue-700">צריך עזרה עם הבקשה שלך?</h2>
      <p className="mb-4">שירות הלקוחות שלנו זמין לסייע לך בכל שאלה על הלוואות או תהליך הבקשה.</p>
      
      <div className="space-y-3">
        <div className="flex items-center">
          <Mail className="h-5 w-5 text-blue-600 ml-3" />
          <span>אימייל: <a href="mailto:asiakaspalvelu@lainasampo.fi" className="text-blue-600 hover:underline">asiakaspalvelu@lainasampo.fi</a></span>
        </div>
        
        <div className="flex items-center">
          <Clock className="h-5 w-5 text-blue-600 ml-3" />
          <span>שעות שירות לקוחות: שני-שישי 9:00-17:00</span>
        </div>
      </div>
      
      <div className="mt-6">
        <Link 
          to="/hebrew/apply" 
          className="inline-block text-blue-600 font-medium hover:underline"
        >
          חזור לבקשת הלוואה
        </Link>
      </div>
    </div>
  );
};
